import { NotificationState } from "../reducers/notification.reducer";

/** ---- Dispatch Types ---- */
export const RESET_NOTIFICATION = "RESET_NOTIFICATION";
export const SET_NOTIFICATION = "SET_NOTIFICATION";

/** ---- Dispatch Interfaces ---- */
interface SetNotification {
  type: typeof SET_NOTIFICATION;
  payload: NotificationState;
}

interface ResetNotification {
  type: typeof RESET_NOTIFICATION;
}

export type NotificationAction = SetNotification | ResetNotification;
